import { render } from "./policies-model.vue?vue&type=template&id=2fab63fc"
import script from "./policies-model.vue?vue&type=script&lang=js"
export * from "./policies-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__